/* =======================================================
   Read more toggle (KEEP AS IS)
======================================================= */
function toggleReadMore(element) {
  var sectionId = element.getAttribute("data-section-id");
  var dots = document.getElementById(sectionId + "_dots");
  var moreText = document.getElementById(sectionId + "_more");
  var btnText = document.getElementById(sectionId + "_myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    moreText.style.display = "none";
    btnText.innerHTML = "read more";
  } else {
    dots.style.display = "none";
    moreText.style.display = "inline";
    btnText.innerHTML = "read less";
  }
}

/* =======================================================
   FIX: Prevent variant swatch focus from scrolling the page (mobile)
======================================================= */

(() => {
  if (window.__PREVENT_FOCUS_SCROLL_V1__) return;
  window.__PREVENT_FOCUS_SCROLL_V1__ = true;

  const isMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 749px)").matches;

  const origFocus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function (options) {
    try {
      if (!isMobile()) return origFocus.call(this, options);

      const el = this;
      const isVariantInput =
        el &&
        el.matches &&
        el.matches(
          '.swatch-input__input, variant-radios input, variant-selects select, .product-form__input input, .product-form__input select'
        );

      if (isVariantInput) {
        return origFocus.call(el, { preventScroll: true });
      }
    } catch (e) {}

    return origFocus.call(this, options);
  };
})();



/* =======================================================
   ✅ Unified Variant Orchestrator (single source of truth)
======================================================= */

(function () {
  if (window.__UNIFIED_VARIANT_ORCHESTRATOR_V1__) return;
  window.__UNIFIED_VARIANT_ORCHESTRATOR_V1__ = true;

  function getVariantIdInput() {
    return (
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('form[id^="product-form-"] input[name="id"]')
    );
  }

  // Expose one handler that other scripts can call if needed.
  window.__ON_VARIANT_ID_CHANGED__ = function (variantId) {
    if (!variantId) return;

    // Price + SKU updater
    if (typeof window.__APPLY_PRODUCTDATA_VARIANT_UI__ === "function") {
      window.__APPLY_PRODUCTDATA_VARIANT_UI__(variantId);
    }

    // Gallery sync (AI gallery)
    if (typeof window.__SYNC_GALLERY_TO_VARIANT__ === "function") {
      window.__SYNC_GALLERY_TO_VARIANT__(variantId);
    }
  };

  // Property-safe watcher (reliable)
  let last = null;
  setInterval(() => {
    const input = getVariantIdInput();
    if (!input) return;

    const current = String(input.value || "");
    if (!current || current === last) return;

    last = current;

    if (typeof window.__ON_VARIANT_ID_CHANGED__ === "function") {
      window.__ON_VARIANT_ID_CHANGED__(current);
    }
  }, 200);

  // Initial run
  document.addEventListener("DOMContentLoaded", () => {
    const input = getVariantIdInput();
    if (input && input.value) {
      last = String(input.value);

      if (typeof window.__ON_VARIANT_ID_CHANGED__ === "function") {
        window.__ON_VARIANT_ID_CHANGED__(last);
      }
    }
  });
})();

/* =======================================================
   Dawn Variant -> AI Gallery Sync (cleaned + callable)
======================================================= */
document.addEventListener("DOMContentLoaded", function () {
  const productData = window.ProductData;

  function normalize(s) {
    return String(s || "").trim().toLowerCase();
  }

  function getVariantBestAlt(variant) {
    if (!variant) return "";
    const fmAlt = variant.featured_media?.alt || "";
    if (fmAlt) return fmAlt;
    const fiAlt = variant.featured_image?.alt || "";
    if (fiAlt) return fiAlt;
    return variant.option1 || variant.option2 || variant.option3 || "";
  }

  function updateLegendSelectedValue(value) {
    const val = String(value || "").trim();
    if (!val) return;

    const legends = Array.from(document.querySelectorAll("legend.form__label"));
    const candidates = legends.filter((l) => l.querySelector("span[data-selected-value]"));
    if (!candidates.length) return;

    const legendToUpdate =
      candidates.find((l) => normalize(l.textContent).includes("colour")) || candidates[0];

    const span = legendToUpdate.querySelector("span[data-selected-value]");
    if (span) span.textContent = val;
  }

  function findAiThumbByAlt(alt) {
    const target = normalize(alt);
    if (!target) return null;

    const thumbs = Array.from(document.querySelectorAll('[class*="ai-product-gallery-thumbnail-"]'));
    if (!thumbs.length) return null;

    let match = thumbs.find((t) => normalize(t.querySelector("img")?.getAttribute("alt")) === target);
    if (match) return match;

    match = thumbs.find((t) => {
      const a = normalize(t.querySelector("img")?.getAttribute("alt"));
      return a && (a.includes(target) || target.includes(a));
    });

    return match || null;
  }

  // ✅ IMPORTANT CHANGE: set a flag so global.js doesn't run thumb->variant + scroll restore
  function clickThumbSafely(thumbEl) {
    if (!thumbEl) return;
    const clickable = thumbEl.querySelector("button, a, [role='button']") || thumbEl;

    window.__AI_GALLERY_SYNC_CLICK__ = true;
    // clear flag shortly after capture handlers run
    setTimeout(() => { window.__AI_GALLERY_SYNC_CLICK__ = false; }, 0);

    clickable.dispatchEvent(
      new MouseEvent("click", { bubbles: true, cancelable: true, view: window })
    );
  }

  function getVariantById(id) {
    const vid = Number(id);
    const variants = productData?.variants;
    if (!vid || !Array.isArray(variants)) return null;
    return variants.find((v) => Number(v.id) === vid) || null;
  }

  window.__SYNC_GALLERY_TO_VARIANT__ = function (variantId) {
    const v = getVariantById(variantId);
    if (!v) return;

    updateLegendSelectedValue(v.option1 || v.option2 || v.option3 || "");

    const alt = getVariantBestAlt(v);
    const thumb = findAiThumbByAlt(alt) || findAiThumbByAlt(v.option1 || "");
    if (thumb) clickThumbSafely(thumb);
  };

  const idInput =
    document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
    document.querySelector('form[id^="product-form-"] input[name="id"]');

  if (idInput?.value) {
    window.__SYNC_GALLERY_TO_VARIANT__(idInput.value);
  }
});

/* =======================================================
   Custom Variant Availability Fix - generic v22
   ✅ Works with Length/Diameter
   ✅ Works with Length/Tip (and any two-option pill picker)
   ✅ Uses the product's real option names instead of hardcoding
   ✅ Throttled to one run per frame, skips no-op writes
   ✅ Guarded against accidental double-include
======================================================= */
if (!window.__AVAIL_FIX_V22__) {
  window.__AVAIL_FIX_V22__ = true;

  var normalizeOptionValue = function (val) {
    if (!val) return "";
    return String(val).trim().toLowerCase().replace(/\s+/g, " ");
  };

  var normalizeDiameter = function (val) {
    if (!val) return "";
    var cleaned = String(val).trim().replace(/\s+/g, "").replace(/mm$/i, "");
    var num = parseFloat(cleaned);
    return isNaN(num) ? cleaned.toLowerCase() : num.toFixed(2) + "mm";
  };

  var normalizeByOptionName = function (optionName, value) {
    var name = String(optionName || "").trim().toLowerCase();
    if (name.indexOf("diameter") !== -1) return normalizeDiameter(value);
    return normalizeOptionValue(value);
  };

  var getVariantsSafe = function (root) {
    var localJson = root && root.querySelector('script[type="application/json"][data-variant-json]');
    if (localJson) {
      try {
        var v = JSON.parse(localJson.textContent || "[]");
        if (Array.isArray(v)) return v;
      } catch (e) {}
    }

    if (window.ProductData && Array.isArray(window.ProductData.variants)) return window.ProductData.variants;
    if (window.productData && Array.isArray(window.productData.variants)) return window.productData.variants;

    var anyJson =
      document.querySelector('script[type="application/json"][data-variant-json]') ||
      document.querySelector("[data-variant-json]");
    if (anyJson) {
      try {
        var v2 = JSON.parse(anyJson.textContent || "[]");
        if (Array.isArray(v2)) return v2;
      } catch (e) {}
    }

    return [];
  };

  var getProductOptionNames = function () {
    var opts = window.ProductData && window.ProductData.options;
    if (Array.isArray(opts) && opts.length) {
      return opts.map(function (o) { return String(o || "").trim(); });
    }
    return [];
  };

  var findFieldsetAfterLegend = function (root, legendIncludes) {
    var legends = Array.prototype.slice.call(root.querySelectorAll("legend.form__label"));
    var wanted = String(legendIncludes || "").trim().toLowerCase();

    for (var i = 0; i < legends.length; i++) {
      var leg = legends[i];
      var t = (leg.textContent || "").trim().toLowerCase();
      if (t.indexOf(wanted) === -1) continue;

      var el = leg.nextElementSibling;
      while (el && el.tagName !== "FIELDSET") el = el.nextElementSibling;

      if (el && el.tagName === "FIELDSET") return el;
    }

    return null;
  };

  var applyGenericAvailability = function (reason) {
    var vs =
      document.querySelector("variant-selects") ||
      document.getElementById("variant-selects-template--27012270784795__main");

    if (!vs) return;

    var optionNames = getProductOptionNames();
    if (optionNames.length < 2) return;

    var option1Name = optionNames[0];
    var option2Name = optionNames[1];

    var option1Fieldset = findFieldsetAfterLegend(vs, option1Name);
    var option2Fieldset = findFieldsetAfterLegend(vs, option2Name);

    if (!option1Fieldset || !option2Fieldset) return;

    var selectedOption1Input = option1Fieldset.querySelector('input[type="radio"]:checked');
    if (!selectedOption1Input) return;

    var selectedOption1 = (selectedOption1Input.value || "").trim();
    var selectedOption1Norm = normalizeByOptionName(option1Name, selectedOption1);

    var variants = getVariantsSafe(vs);
    if (!variants.length) return;

    var allowed = new Set();

    variants.forEach(function (v) {
      var vOpt1 = normalizeByOptionName(option1Name, v.option1 || "");
      var vOpt2 = normalizeByOptionName(option2Name, v.option2 || "");

      if (vOpt1 === selectedOption1Norm && v.available) {
        allowed.add(vOpt2);
      }
    });

    option2Fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      var rawValue = (radio.value || "").trim();
      var normValue = normalizeByOptionName(option2Name, rawValue);
      var enable = allowed.has(normValue);

      // Skip entirely when nothing would change — avoids re-triggering the observer
      if (radio.disabled === !enable) {
        var lbl = radio.nextElementSibling;
        if (!lbl || lbl.tagName !== "LABEL") return;
        if (lbl.classList.contains("disabled") === !enable) return;
      }

      if (enable) {
        radio.disabled = false;
        radio.removeAttribute("disabled");
        radio.classList.remove("disabled");
        radio.setAttribute("aria-disabled", "false");
      } else {
        radio.disabled = true;
        radio.setAttribute("disabled", "disabled");
        radio.classList.add("disabled");
        radio.setAttribute("aria-disabled", "true");
      }

      var label = radio.nextElementSibling;
      if (label && label.tagName === "LABEL") {
        label.classList.toggle("disabled", !enable);
        label.classList.toggle("unavailable", !enable);
      }
    });
  };

  var initAvailV22 = function () {
    applyGenericAvailability("init");

    document.addEventListener("change", function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;

      if (target.matches('variant-selects input[type="radio"]')) {
        applyGenericAvailability("change");
      }
    });

    var availRaf = 0;
    var obs = new MutationObserver(function () {
      if (availRaf) return;
      availRaf = requestAnimationFrame(function () {
        availRaf = 0;
        applyGenericAvailability("mutation");
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener("DOMContentLoaded", initAvailV22);
}

/* =======================================================
   ✅ Price + SKU update from window.ProductData
   - Batches UI work
   - Avoids repeated observers / duplicate retries
======================================================= */
(function () {
  function getVariantById(id) {
    const vid = Number(id);
    const variants = window.ProductData?.variants;
    if (!vid || !Array.isArray(variants)) return null;
    return variants.find((v) => Number(v.id) === vid) || null;
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, "${{amount}}");
    }

    const dollars = Number(cents || 0) / 100;
    return `$${dollars.toFixed(2)}`;
  }

  function updateSku(variant) {
    if (!variant) return;

    const nextSku = variant.sku || "";
    const skuEls = document.querySelectorAll(".product__sku, [data-sku]");

    skuEls.forEach((el) => {
      // Preferred: a dedicated value element, so the label is never touched.
      const valueEl = el.querySelector("[data-sku-value], .product__sku-value");
      if (valueEl) {
        if (valueEl.textContent !== nextSku) valueEl.textContent = nextSku;
        el.classList.toggle("visibility-hidden", !nextSku);
        return;
      }

      // Fallback: the visible "SKU:" label comes from CSS (.product__sku::before),
      // and the markup carries a visually-hidden label for screen readers.
      // Only ever write the value, and keep (or restore) that hidden label.
      let label = el.querySelector(".visually-hidden");
      const labelText = label ? label.textContent : "SKU:";
      const currentValue = el.textContent.replace(labelText, "").trim();
      if (label && currentValue === nextSku) return;

      el.textContent = "";
      label = document.createElement("span");
      label.className = "visually-hidden";
      label.textContent = labelText;
      el.appendChild(label);
      el.appendChild(document.createTextNode(" " + nextSku));
      el.classList.toggle("visibility-hidden", !nextSku);
    });
  }

  function updatePrice(variant) {
    if (!variant) return;

    const main = document.querySelector("main#MainContent") || document;

    const regularTargets = main.querySelectorAll(
      ".price-item--regular, .price__regular .price-item, [data-regular-price]"
    );
    const saleTargets = main.querySelectorAll(
      ".price-item--sale, .price__sale .price-item, [data-sale-price]"
    );

    if (!regularTargets.length && !saleTargets.length) return;

    const price = formatMoney(variant.price);
    const compareAt = variant.compare_at_price ? formatMoney(variant.compare_at_price) : null;
    const onSale = compareAt && variant.compare_at_price > variant.price;
    const regularText = onSale ? compareAt : price;

    saleTargets.forEach((el) => {
      if (el.textContent !== price) el.textContent = price;
    });

    regularTargets.forEach((el) => {
      if (el.textContent !== regularText) el.textContent = regularText;
    });
  }

  function applyVariantUi(variantId) {
    const v = getVariantById(variantId);
    if (!v) return;

    if (window.__IS_KIT_TEMPLATE__) {
      const priceElement = document.querySelector("custom-price");
      if (priceElement && typeof priceElement.updatePrice === "function") {
        priceElement.updatePrice();
      } else {
        updatePrice(v);
      }
    } else {
      updatePrice(v);
    }

    updateSku(v);
  }

  function getCurrentVariantIdFallback() {
    const idInput =
      document.querySelector('product-form form input[name="id"]') ||
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector(".product-variant-id");

    return idInput?.value ? String(idInput.value).trim() : "";
  }

  function applyKitYarnSetOnce(variantId) {
    const id = String(variantId || "").trim();
    if (!id) return false;

    document.querySelectorAll(".yarnSets").forEach((el) => (el.style.display = "none"));
    document.querySelectorAll(".yarnSets .addon-item").forEach((el) =>
      el.classList.remove("active--item")
    );

    const target = document.getElementById("yarn_" + id);
    if (!target) return false;

    target.style.display = "";
    target.style.removeProperty("display");
    target.querySelectorAll(".addon-item").forEach((el) => el.classList.add("active--item"));
    return true;
  }

  function updateKitPrice() {
    const priceElement = document.querySelector("custom-price");
    if (priceElement && typeof priceElement.updatePrice === "function") {
      priceElement.updatePrice();
    }
  }

  function applyKitYarnSetWithRetry(variantId, tries = 4, delay = 20) {
    const wanted = String(variantId || "").trim() || getCurrentVariantIdFallback();
    if (!wanted) return;

    let attempt = 0;

    const tick = () => {
      const current = getCurrentVariantIdFallback() || wanted;
      const ok = applyKitYarnSetOnce(current);

      if (ok) {
        updateKitPrice();
        return;
      }

      attempt += 1;
      if (attempt >= tries) return;
      setTimeout(tick, delay);
    };

    tick();
  }

  let pendingVariantId = "";
  let uiRaf = 0;
  let settleTimer = 0;
  let settleObserver = null;
  let lastAppliedVariantId = "";

  function disconnectSettleObserver() {
    if (settleObserver) {
      try {
        settleObserver.disconnect();
      } catch (e) {}
      settleObserver = null;
    }
    if (settleTimer) {
      clearTimeout(settleTimer);
      settleTimer = 0;
    }
  }

  function settleAfterDomSwap(variantId) {
    disconnectSettleObserver();

    const watchRoot =
      document.querySelector("product-info") ||
      document.querySelector("main#MainContent") ||
      document.body;

    let fired = false;

    settleObserver = new MutationObserver(() => {
      if (fired) return;
      fired = true;

      requestAnimationFrame(() => {
        disconnectSettleObserver();
        const current = getCurrentVariantIdFallback() || variantId;
        applyVariantUi(current);
        applyKitYarnSetWithRetry(current, 4, 20);
      });
    });

    settleObserver.observe(watchRoot, { childList: true, subtree: true });

    settleTimer = setTimeout(() => {
      disconnectSettleObserver();
    }, 220);
  }

  function flushPriceUi() {
    uiRaf = 0;

    const current = String(pendingVariantId || "").trim() || getCurrentVariantIdFallback();
    if (!current) return;
    if (current === lastAppliedVariantId) return;

    lastAppliedVariantId = current;

    applyVariantUi(current);
    applyKitYarnSetWithRetry(current, 4, 20);
    settleAfterDomSwap(current);
  }

  function schedulePriceUi(variantId) {
    pendingVariantId = String(variantId || "").trim() || getCurrentVariantIdFallback();
    if (!pendingVariantId) return;

    if (uiRaf) cancelAnimationFrame(uiRaf);
    uiRaf = requestAnimationFrame(flushPriceUi);
  }

  window.__APPLY_PRODUCTDATA_VARIANT_UI__ = function (variantId) {
    schedulePriceUi(variantId);
  };
})();

/* =======================================================
   Swatch select -> scroll user back to gallery top (mobile, smoother)
   TEMP DIAG: DISABLED FOR TEST 1
======================================================= */

(function () {

  function smoothScrollTo(targetY, duration = 900) {
    const startY = window.scrollY;
    const distance = targetY - startY;
    const startTime = performance.now();

    function easeInOutQuad(t) {
      return t < 0.5
        ? 2 * t * t
        : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeInOutQuad(progress);

      window.scrollTo(0, startY + distance * eased);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }

  document.addEventListener("change", function (e) {
    const input = e.target;

    if (!input || !input.matches(
      'input.swatch-input__input[type="radio"], input.swatch-input__input[type="checkbox"]'
    )) return;

    // Only on mobile
    if (window.innerWidth > 749) return;

    const gallery =
      document.querySelector('[data-ai-gallery="true"]') ||
      document.querySelector('product-media-gallery') ||
      document.querySelector('.product__media-wrapper');

    if (!gallery) return;

    const header =
      document.querySelector("sticky-header") ||
      document.querySelector(".header-wrapper") ||
      document.querySelector("#shopify-section-header");

    const offset = header ? header.getBoundingClientRect().height : 0;

    const top = gallery.getBoundingClientRect().top + window.scrollY - offset - 8;

    smoothScrollTo(top, 1000); // change duration here
  }, true);

})();
/* =======================================================
   Clear add-to-cart error when variant changes
======================================================= */
document.addEventListener('change', function (e) {
  const variantArea = e.target.closest('variant-selects');
  if (!variantArea) return;

  const productInfo = variantArea.closest('product-info');
  if (!productInfo) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const form = productInfo.querySelector('product-form, .product-form, form[action*="/cart/add"]');
      if (!form) return;

      const errorWrapper = form.parentElement?.querySelector('.product-form__error-message-wrapper')
        || productInfo.querySelector('.product-form__error-message-wrapper');

      const errorMessage = errorWrapper?.querySelector('.product-form__error-message');

      if (errorWrapper) {
        errorWrapper.setAttribute('hidden', '');
      }

      if (errorMessage) {
        errorMessage.textContent = '';
      }
    });
  });
});

(function () {
  const MINIMUM_ORDER = 20000;

  function getCartTotal() {
    const el = document.querySelector('[data-cart-total]');
    return el ? parseInt(el.dataset.cartTotal, 10) : 0;
  }

  function enforceMinimumOrder() {
    const isBelowMinimum = getCartTotal() < MINIMUM_ORDER;

    const buttons = [
      document.querySelector('#CartDrawer-Checkout'),
      document.querySelector('#checkout'),
    ];

    buttons.forEach((btn) => {
      if (!btn) return;
      const container = btn.closest('.cart__ctas');
      if (!container) return;

      // Use class to apply !important CSS
      btn.classList.toggle('minimum-order-blocked', isBelowMinimum);

      let errorMsg = container.parentNode.querySelector('.minimum-order-error');
      if (!errorMsg) {
        errorMsg = document.createElement('p');
        errorMsg.className = 'minimum-order-error';
        errorMsg.textContent = 'Minimum order value is $200';
        errorMsg.style.cssText = `
          color: #c0392b;
          background: #fff3f3;
          border: 1px solid #f5a5a5;
          border-radius: 6px;
          padding: 10px 12px;
          margin-top: 8px;
          font-size: 13px;
          font-weight: 500;
          text-align: center;
        `;
        container.insertAdjacentElement('afterend', errorMsg);
      }
      errorMsg.style.display = isBelowMinimum ? 'block' : 'none';
    });

    // Block form submission directly
    const forms = [
      document.querySelector('#CartDrawer-Form'),
      document.querySelector('form[action="/cart"]'),
    ];
    forms.forEach((form) => {
      if (!form) return;
      if (isBelowMinimum) {
        form._submitHandler = form._submitHandler || function (e) {
          if (getCartTotal() < MINIMUM_ORDER) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        };
        form.removeEventListener('submit', form._submitHandler, true);
        form.addEventListener('submit', form._submitHandler, true);
      } else {
        if (form._submitHandler) {
          form.removeEventListener('submit', form._submitHandler, true);
        }
      }
    });

    // Shop Pay / PayPal
    document.querySelectorAll('.shopify-payment-button__button').forEach((btn) => {
      btn.style.setProperty('opacity', isBelowMinimum ? '0.5' : '1', 'important');
      btn.style.setProperty('pointer-events', isBelowMinimum ? 'none' : 'all', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', enforceMinimumOrder);

  const observer = new MutationObserver(enforceMinimumOrder);
  document.addEventListener('DOMContentLoaded', () => {
    const targets = [
      document.querySelector('cart-drawer'),
      document.querySelector('#main-cart-footer'),
    ];
    targets.forEach((el) => {
      if (el) observer.observe(el, { childList: true, subtree: true, attributes: true, characterData: true });
    });
  });

  ['cart:updated', 'cart:refresh', 'theme:cart:updated'].forEach((evt) => {
    document.addEventListener(evt, enforceMinimumOrder);
  });
})();
// ============================================================
// PRODUCT PAGE — ORDER MULTIPLES + INVENTORY ENFORCEMENT
// ============================================================
(function () {
  if (!document.querySelector('product-info')) return;

  let lastVariantId = null;

  function getInventoryData() {
    const el = document.getElementById('pdp-inventory-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function getCurrentVariantId() {
    const input = document.querySelector('product-info input[name="id"]')
      || document.querySelector('form[id^="product-form-"] input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function getVariantInfo(variantId) {
    const data = getInventoryData();
    if (!data) return null;
    return data.variants.find(v => v.id === variantId) || null;
  }

  function getOrderMultiple() {
    const data = getInventoryData();
    return data ? (parseInt(data.order_multiple) || 1) : 1;
  }

  function getSectionId() {
    const el = document.querySelector('product-info[data-section]');
    return el ? el.dataset.section : null;
  }

  function getQtyInput() {
    const sectionId = getSectionId();
    return sectionId
      ? document.getElementById(`Quantity-${sectionId}`)
      : document.querySelector('.product-form__quantity .quantity__input');
  }

  function getAddToCartBtn() {
    return document.querySelector('product-info .product-form__submit');
  }

  function getOrCreateError() {
    let el = document.getElementById('pdp-qty-error');
    if (!el) {
      el = document.createElement('p');
      el.id = 'pdp-qty-error';
      el.style.cssText = `
        color: #c0392b;
        background: #fff3f3;
        border: 1px solid #f5a5a5;
        border-radius: 6px;
        padding: 8px 12px;
        margin: 0 0 10px 0;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4;
        display: none;
        width: 100%;
        box-sizing: border-box;
      `;
      // Insert before the quantity-add__button wrapper (which contains qty + add to cart)
      const qtyAddBtn = document.querySelector('.quantity-add__button')
        || document.querySelector('.product-form__buttons')
        || document.querySelector('[id^="Quantity-Form-"]');
      if (qtyAddBtn) {
        qtyAddBtn.parentNode.insertBefore(el, qtyAddBtn);
      } else {
        const productInfo = document.querySelector('product-info');
        if (productInfo) productInfo.appendChild(el);
      }
    }
    return el;
  }

  function showError(msg) {
    const el = getOrCreateError();
    el.textContent = msg;
    el.style.display = 'block';
  }

  function clearError() {
    const el = document.getElementById('pdp-qty-error');
    if (el) el.style.display = 'none';
  }

  function setAddToCartState(disabled) {
    const btn = getAddToCartBtn();
    if (!btn) return;
    if (disabled) {
      btn.classList.add('minimum-order-blocked');
      const form = btn.closest('form');
      if (form && !form._pdpSubmitBlocked) {
        form._pdpSubmitBlocked = true;
        form.addEventListener('submit', function (e) {
          if (form._pdpSubmitBlocked) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }, true);
      }
      if (form) form._pdpSubmitBlocked = true;
    } else {
      btn.classList.remove('minimum-order-blocked');
      const form = btn.closest('form');
      if (form) form._pdpSubmitBlocked = false;
    }
  }

  function enforce() {
    const variantId = getCurrentVariantId();
    if (!variantId) return;

    const variant = getVariantInfo(variantId);
    const orderMultiple = getOrderMultiple();
    const qtyInput = getQtyInput();
    if (!qtyInput) return;

    const currentQty = parseInt(qtyInput.value, 10) || orderMultiple;

    const isTracked = variant && variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';
    const isUnavailable = variant && !variant.available && variant.inventory_management !== 'shopify';

    if (isUnavailable) {
      showError(`This colour is currently out of stock and cannot be ordered.`);
      setAddToCartState(true);
      qtyInput.disabled = true;
      return;
    }

    if (!isTracked) {
      if (orderMultiple > 1 && currentQty % orderMultiple !== 0) {
        const snapped = Math.max(orderMultiple, Math.round(currentQty / orderMultiple) * orderMultiple);
        qtyInput.value = snapped;
        showError(`This product must be ordered in multiples of ${orderMultiple}. Quantity adjusted to ${snapped}.`);
        setTimeout(clearError, 3000);
      } else {
        clearError();
      }
      setAddToCartState(false);
      qtyInput.disabled = false;
      return;
    }

    const inventoryQty = variant.inventory_quantity;

    if (inventoryQty < orderMultiple) {
      showError(`Unfortunately there is only ${inventoryQty} in stock and the minimum order quantity is ${orderMultiple}, so you cannot place an order for this product.`);
      setAddToCartState(true);
      qtyInput.disabled = true;
      return;
    }

    if (currentQty > inventoryQty) {
      const maxValid = Math.floor(inventoryQty / orderMultiple) * orderMultiple;
      if (maxValid < orderMultiple) {
        showError(`Unfortunately there is only ${inventoryQty} in stock and the minimum order quantity is ${orderMultiple}, so you cannot place an order for this product.`);
        setAddToCartState(true);
        qtyInput.disabled = true;
        return;
      }
      qtyInput.value = maxValid;
      showError(`Only ${inventoryQty} in stock. Quantity adjusted to ${maxValid}.`);
      setAddToCartState(false);
      qtyInput.disabled = false;
      return;
    }

    if (orderMultiple > 1 && currentQty % orderMultiple !== 0) {
      const snapped = Math.round(currentQty / orderMultiple) * orderMultiple;
      const safeQty = snapped > inventoryQty
        ? Math.floor(inventoryQty / orderMultiple) * orderMultiple
        : snapped;
      qtyInput.value = safeQty || orderMultiple;
      showError(`This product must be ordered in multiples of ${orderMultiple}. Quantity adjusted to ${qtyInput.value}.`);
      setTimeout(clearError, 3000);
      setAddToCartState(false);
      qtyInput.disabled = false;
      return;
    }

    clearError();
    setAddToCartState(false);
    qtyInput.disabled = false;
  }

  function applyConstraints() {
    const qtyInput = getQtyInput();
    if (!qtyInput) return;

    const orderMultiple = getOrderMultiple();
    const variantId = getCurrentVariantId();

    qtyInput.setAttribute('min', orderMultiple);
    qtyInput.setAttribute('step', orderMultiple);
    qtyInput.setAttribute('data-min', orderMultiple);

    const currentVal = parseInt(qtyInput.value, 10);
    if (!currentVal || currentVal % orderMultiple !== 0) {
      qtyInput.value = orderMultiple;
    }

    if (variantId) {
      const variant = getVariantInfo(variantId);
      if (variant && variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue') {
        const maxValid = Math.floor(variant.inventory_quantity / orderMultiple) * orderMultiple;
        if (maxValid > 0) {
          qtyInput.setAttribute('max', maxValid);
        } else {
          qtyInput.removeAttribute('max');
        }
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    enforce();
  }

  function init() {
    const qtyInput = getQtyInput();
    if (!qtyInput) return;

    setTimeout(applyConstraints, 400);

    qtyInput.addEventListener('change', enforce);
    qtyInput.addEventListener('input', enforce);

    const qtyWrapper = qtyInput.closest('quantity-input');
    if (qtyWrapper) {
      qtyWrapper.addEventListener('click', (e) => {
        if (e.target.closest('.quantity__button')) setTimeout(enforce, 50);
      });
    }

    // Poll for variant changes every 300ms
    setInterval(() => {
      const currentId = getCurrentVariantId();
      if (currentId && currentId !== lastVariantId) {
        lastVariantId = currentId;
        setTimeout(applyConstraints, 400);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// ============================================================
// CART DRAWER — ORDER MULTIPLES ENFORCEMENT
// ============================================================
(function () {
  function getOrderMultipleForInput(input) {
    const step = parseInt(input.getAttribute('step'), 10);
    return step > 1 ? step : 1;
  }

  function enforceCartMultiples(input) {
    const orderMultiple = getOrderMultipleForInput(input);
    if (orderMultiple <= 1) return;

    const currentVal = parseInt(input.value, 10);
    if (!currentVal || currentVal % orderMultiple !== 0) {
      const snapped = Math.max(orderMultiple, Math.round(currentVal / orderMultiple) * orderMultiple);
      input.value = snapped;
      // Trigger Dawn's change event so the cart updates
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Watch for clicks on cart drawer +/- buttons
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-quantity .quantity__button');
    if (!btn) return;
    const input = btn.closest('quantity-input')?.querySelector('.quantity__input');
    if (!input) return;
    setTimeout(() => enforceCartMultiples(input), 50);
  });

  // Watch for manual input changes in cart drawer
  document.addEventListener('change', (e) => {
    if (!e.target.closest('.cart-quantity')) return;
    enforceCartMultiples(e.target);
  });
})();

/* =========================================================
   MS-246: keep option headings ("Length: 60cm", "Diameter: 2.75mm")
   in sync with the selected pill. The theme only re-renders the picker
   on some option changes, so a later option's heading could go stale.
   Independent of the variant chain above; reads state only from the DOM.
========================================================= */
(function () {
  if (window.__OPTION_LEGEND_SYNC_V1__) return;
  window.__OPTION_LEGEND_SYNC_V1__ = true;

  function syncLegends(selects) {
    if (!selects) return;
    const fieldsets = selects.querySelectorAll("fieldset.product-form__input");
    const values = selects.querySelectorAll("legend.form__label [data-selected-value]");
    fieldsets.forEach((fieldset, i) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && values[i] && values[i].textContent !== checked.value) {
        values[i].textContent = checked.value;
      }
    });
  }

  document.addEventListener("change", (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "radio") return;
    syncLegends(input.closest("variant-selects"));
  });
})();
